import { gql, useLazyQuery } from "@apollo/client";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { GET_SUPPORT_TOTAL_UNREAD_COUNT } from '../../constants/support/support';

// ========================GET SUPPORT TOTAL UNREAD COUNT========================
const SUPPORT_TOTAL_UNREADS_COUNT = gql`
  query SupportTotalUnreadCount {
    supportTotalUnreadCount {
      success
      message
      data {
        totalUnreadCount
      }
    }
  }
`;

export const GetSupportTotalUnreadCountAction = () => {
  const dispatch = useDispatch();
  const [
    fetchSupportTotalUnreadCount, // Function to trigger the query
    supportTotalUnreadCountResponse, // Response data
  ] = useLazyQuery(SUPPORT_TOTAL_UNREADS_COUNT, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-and-network",
    onCompleted: ({ supportTotalUnreadCount: responseData }) => {
      if (responseData.success) {
        dispatch({
          type: GET_SUPPORT_TOTAL_UNREAD_COUNT,
          payload: responseData?.data,
        });
        // toast.success(responseData?.message)
      } else {
        // toast.error(responseData?.message)
      }
    },
  });

  // Variable to access the query response data
  const supportUnreadCountQueryData = supportTotalUnreadCountResponse;

  // Function to initialize the query
  const initSupportTotalUnreadCount = (variables) => {
    fetchSupportTotalUnreadCount({ variables });
  };

  return { supportUnreadCountQueryData, initSupportTotalUnreadCount };
};
